import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import { ActionsWidgetStore } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/actionsWidgetStore'
import { HandOffActionWidget } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/HandOffActionWidget/HandOffActionWidget.tsx'
import { ActionsWidgetUi } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ActionsWidgetUi.tsx'

export const ActionsWidget = observer(() => {
  const { instructionsSectionStore, chatStore, entities } = useUnifiedAgentContext()
  const [store] = useState(
    () => new ActionsWidgetStore(instructionsSectionStore, chatStore, entities)
  )

  useEffect(() => {
    return () => {
      store.reset()
    }
  }, [])

  if (store.handOffActionWidgetStore) {
    return <HandOffActionWidget store={store.handOffActionWidgetStore} />
  }
  return <ActionsWidgetUi store={store} />
})
